import styled from 'styled-components';
import { POPPER_HEADER_HEIGHT } from '../../styles/dimensions';

export const JsonModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: min(80vw, 960px);
  height: min(60vh, 720px);
  max-height: calc(80vh - ${POPPER_HEADER_HEIGHT}px);
`;

export const JsonModalHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing8}px;
  margin-bottom: ${({ theme }) => theme.spacing8}px;
`;

export const JsonModalTabBar = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing4}px;
`;

/** Hidden copy of the active document so existing Cypress specs can still read a `<pre>`. */
export const JsonModalSourcePre = styled.pre`
  display: none;
`;

export const JsonModalTabPanel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  width: 100%;
`;

export const JsonModalCopyHint = styled.div`
  flex-shrink: 0;
  margin-left: auto;
  text-align: right;
`;
